export default __webpack_public_path__ + "static/media/appstore-btn.a32c9c88.svg";